import { PropsWithChildren, ReactElement } from 'react';
import classNames from 'classnames';
import { noop } from 'lodash';

import { TypistSpeed } from '../Typist';

import { MessageOrigin } from './Message.types';
import { MessageContext } from './Message.context';
import { MessageAvatar } from './MessageAvatar/MessageAvatar';
import { MessageContent } from './MessageContent/MessageContent';

import styles from './Message.module.scss';

export type MessageProps = PropsWithChildren<{
  origin: MessageOrigin;
  isTyping?: boolean;
  animate?: TypistSpeed;
  onAnimationCompleted?: () => void;
}>;

interface MessageComponent {
  (props: MessageProps): ReactElement;
  Avatar: typeof MessageAvatar;
  Content: typeof MessageContent;
}

export const Message: MessageComponent = ({
  children,
  origin,
  animate,
  isTyping = false,
  onAnimationCompleted = noop,
}) => {
  return (
    <MessageContext.Provider
      value={{ origin, isTyping, animate, onAnimationCompleted }}
    >
      <div className={classNames(styles.root, styles[origin])}>{children}</div>
    </MessageContext.Provider>
  );
};

Message.Content = MessageContent;
Message.Avatar = MessageAvatar;
